import TagManager from 'react-gtm-module';

export interface TrackOutfittingAnchorClickProps {
  data: {
    /**
     * PDP path the click happened on, including the query string, e.g.
     * `/en/product/6037-633/arcteryx-olera-zip-neck-womens?colour=Solitude` —
     * the selected colour is part of what the shopper was looking at.
     */
    interactionLocation: string;
    /** The anchor heading, as configured in Prismic per locale. */
    linkText: string;
  };
}

/**
 * The anchor scrolls in-page rather than navigating, so no `link_url` is sent —
 * there is no destination URL to report.
 */
export const trackOutfittingAnchorClick = ({
  data,
}: TrackOutfittingAnchorClickProps) => {
  const { interactionLocation, linkText } = data;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_outfitting_anchor',
      interaction: {
        interaction_location: interactionLocation,
        link_text: linkText,
      },
    },
  });
};
